import React, { useEffect, useRef } from "react";
import "./CheckBoxInput.css";
import CustomError from "../Errors/CustomError";

const CheckboxInput = ({
  label,
  name,
  value = "",
  checked,
  indeterminate = false,
  handleTextChange,
  parentClassName = "",
  checkBoxClassName = "",
  labelClassName = "",
  parentStyle = {},
  checkboxStyle = {},
  labelStyle = {},
  disabled = false,
  readOnly = false,
  required = false,
  customError,
}) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <>
      <div
        className={
          parentClassName?.trim()
            ? parentClassName
            : "default-checkbox-parent-class"
        }
        style={parentStyle}
      >
        <input
          ref={checkboxRef}
          name={name}
          type="checkbox"
          value={value}
          checked={checked}
          onChange={handleTextChange}
          className={
            checkBoxClassName?.trim()
              ? checkBoxClassName
              : "default-checkbox-input-class"
          }
          style={checkboxStyle}
          disabled={disabled}
          readOnly={readOnly}
          required={required}
        />

        <label
          className={
            labelClassName?.trim()
              ? labelClassName
              : "default-checkbox-label-class"
          }
          style={labelStyle}
        >
          {label}
        </label>
      </div>

      {customError && <CustomError error={customError} />}
    </>
  );
};

export default CheckboxInput;
